import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const TurnOningIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g filter="url(#filter0_dddd_790_27309)">
        <rect x="6" y="6" width="47" height="20" rx="10" fill={fillColor || 'url(#paint0_linear_790_27309)'} />
        <rect x="6.5" y="6.5" width="46" height="19" rx="9.5" stroke="url(#paint1_linear_790_27309)" />
      </g>
      <g opacity="0.3" filter="url(#filter1_f_790_27309)">
        <path
          d="M5 16C5 22.0751 9.92487 27 16 27H44C50.0751 27 55 22.0751 55 16C55 22.6274 50.6274 28 44 28H16C9.37258 28 5 22.6274 5 16Z"
          fill={fillColor || '#838383'}
        />
      </g>
      <g filter="url(#filter2_i_790_27309)">
        <path
          d="M10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16Z"
          fill={fillColor || 'url(#paint2_linear_790_27309)'}
        />
      </g>
      <circle opacity="0.4" cx="16" cy="14" r="3" fill={fillColor || 'url(#paint3_linear_790_27309)'} />
      <path
        d="M32.025 20.121C30.958 20.121 30.199 19.582 29.814 18.823C29.484 18.218 29.44 17.305 29.44 16.15C29.44 14.995 29.484 14.082 29.814 13.477C30.199 12.718 30.958 12.179 32.025 12.179C33.092 12.179 33.851 12.718 34.236 13.477C34.566 14.082 34.61 14.995 34.61 16.15C34.61 17.305 34.566 18.218 34.236 18.823C33.851 19.582 33.092 20.121 32.025 20.121ZM30.529 16.15C30.529 16.953 30.54 17.756 30.716 18.196C30.969 18.801 31.464 19.065 32.025 19.065C32.586 19.065 33.081 18.801 33.334 18.196C33.51 17.756 33.521 16.953 33.521 16.15C33.521 15.347 33.51 14.544 33.334 14.104C33.081 13.499 32.586 13.235 32.025 13.235C31.464 13.235 30.969 13.499 30.716 14.104C30.54 14.544 30.529 15.347 30.529 16.15ZM35.6529 20C35.5319 20 35.4329 19.901 35.4329 19.78V12.52C35.4329 12.399 35.5319 12.3 35.6529 12.3H36.5329C36.6649 12.3 36.7199 12.355 36.7749 12.487L38.8209 17.657C38.8539 17.756 38.9969 17.734 38.9969 17.635V12.52C38.9969 12.399 39.0959 12.3 39.2169 12.3H39.8329C39.9539 12.3 40.0529 12.399 40.0529 12.52V19.78C40.0529 19.901 39.9539 20 39.8329 20H38.9529C38.8209 20 38.7659 19.945 38.7109 19.813L36.6649 14.643C36.6319 14.544 36.4889 14.566 36.4889 14.665V19.78C36.4889 19.901 36.3899 20 36.2689 20H35.6529Z"
        fill={fillColor || 'url(#paint4_linear_790_27309)'}
      />
      <defs>
        <filter
          id="filter0_dddd_790_27309"
          x="4"
          y="2"
          width="50"
          height="24"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_790_27309" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-1" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_790_27309" result="effect2_dropShadow_790_27309" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="-1" dy="-2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_790_27309" result="effect3_dropShadow_790_27309" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dx="-1" dy="-3" />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0" />
          <feBlend mode="normal" in2="effect3_dropShadow_790_27309" result="effect4_dropShadow_790_27309" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_790_27309" result="shape" />
        </filter>
        <filter id="filter1_f_790_27309" x="3" y="14" width="54" height="16" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur_790_27309" />
        </filter>
        <filter id="filter2_i_790_27309" x="10" y="10" width="12" height="13" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.0980392 0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0.5 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_790_27309" />
        </filter>
        <linearGradient id="paint0_linear_790_27309" x1="8.85811" y1="6.66667" x2="20.5674" y2="36.9151" gradientUnits="userSpaceOnUse">
          <stop stopColor="#202224" />
          <stop offset="1" stopColor="#161819" />
        </linearGradient>
        <linearGradient id="paint1_linear_790_27309" x1="43.0577" y1="7" x2="48.5105" y2="25.7282" gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0" />
          <stop offset="1" stopColor="#666666" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient id="paint2_linear_790_27309" x1="16" y1="22" x2="16" y2="10" gradientUnits="userSpaceOnUse">
          <stop stopColor="#D44F25" />
          <stop offset="1" stopColor="#FF5B27" />
        </linearGradient>
        <linearGradient id="paint3_linear_790_27309" x1="16" y1="17" x2="16" y2="11" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient id="paint4_linear_790_27309" x1="29.7297" y1="12.2667" x2="35.8983" y2="22.4381" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF5C28" />
          <stop offset="1" stopColor="#C24118" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export { TurnOningIcon };
